<template>
  <a-modal
    :title="selectTit"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :width="640"
    :centered="true"
    :mask-closable="false"
    wrap-class-name="filter-config-modal"
    :destroy-on-close="true"
    :footer="null"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="content clearfix">
      <div class="left fl">
        <h3>{{ $t('message["570"]') }}</h3>
        <div
          v-if="treeData"
          class="result scroll_bar_beautify_ff"
        >
          <a-tree
            v-if="treeData[0] && treeData[0].fieldkey"
            ref="treeList"
            checkable
            :default-expanded-keys="[treeData[0].fieldkey]"
            :tree-data="treeData"
            :checked-keys="checkedKeys"
            @check="onCheck"
          />
        </div>
      </div>
      <span class="border" />
      <div class="right fl">
        <h3>{{ $t('message["1480"]') }}</h3>
        <draggable
          v-model="myList"
          :options="{
            animation: 60,
            handle:'.dray-item'
          }"
          class="result scroll_bar_beautify_ff"
          @end="dragEndHandle"
        >
          <transition-group>
            <div
              v-for="(item, i) in myList"
              :key="i"
              class="item clearfix"
              :class="{ 'active': item.active}"
            >
              <div class="dray-item fl">
                <i class="iconfont iconicon-test72 move-icon" />
                <span>{{ item.fieldname }}</span>
              </div>
              <i
                class="iconfont iconicon-test5 fr close-icon"
                @click="onDeleteItem(item, i)"
              />
            </div>
          </transition-group>
        </draggable>
      </div>
    </div>
    <div class="footer">
      <a-button
        class="ml-16"
        @click="handleCancel"
      >
        {{ $t('message["896"]') }}
      </a-button>
      <a-button
        :disabled="!myList.length"
        type="primary"
        @click="handleOk"
      >
        {{ $t('message["915"]') }}
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import eventBus from '@/lib/eventBus'
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
export default {
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: ''
    },
    type: {
      type: [String, Number],
      default: ''
    },
    paramsType: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      isVisible: false,
      confirmLoading: false,
      checkedKeys: [],
      resultKeys: []
    }
  },
  computed: {
    ...mapState('inquery/filterData', ['filterAllData', 'filterSort']),
    treeData () {
      let data = JSON.parse(JSON.stringify(this.filterAllData))
      let obj = {}
      obj.child = data
      // console.log(obj)
      this.prepareTreeData(obj)
      return obj.children
    },
    myList: {
      get () {
        let data = JSON.parse(JSON.stringify(this.filterSort))
        return _.reduce(data, (res, item) => {
          res.push(item)
          return res
        }, [])
      },
      set (value) {
        this.$store.commit('SET_FILTER_SORT', value)
      }
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    selectTit () {
      return this.$t('message["961"]')
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
      if (val) {
        eventBus.$emit('getQuery')
        document.body.style.overflow = 'hidden'
      } else {
        setTimeout(() => {
          document.body.style.overflow = 'hidden'
        }, 300)
      }
    },
    treeData (val) {
      this.checkedKeys = []
      this.getCheckedKeys(val)
    }
  },
  created () {
    // this.prepareInitData()
  },
  methods: {
    ...mapActions('inquery/filterData', ['setQuery']),
    prepareInitData () {
      for (let k in this.filterAllData) {
        const modules = this.filterAllData[k] || {}
        const child = modules.child || []
        for (let i in child) {
          let item = child[i]
          const ischecked = item.ischecked === undefined ? 0 : item.ischecked
          this.$set(item, 'ischecked', ischecked)
        }
      }
    },
    hide () {
      this.$emit('update:visible', false)
      eventBus.$emit('showFilter')
    },
    onChange (item) {
      const ischecked = item.ischecked === 1 ? 0 : 1
      this.$set(item, 'ischecked', ischecked)
    },
    setFilterAllResult () {
      let arr = []
      for (let k in this.filterAllData) {
        const modules = this.filterAllData[k] || {}
        const child = modules.child || []
        for (let i in child) {
          let item = child[i]
          if (item.ischecked) {
            arr.push(item.fieldkey)
          }
        }
      }
      return arr
    },
    handleOk () {
      this.resultKeys = this.myList.map(item => item.fieldkey)
      // const filterAllResult = this.setFilterAllResult()
      this.setFilter(this.resultKeys)
      this.hide()
    },
    async setFilter (result) {
      const chain = await this.setQuery()
      chain
        .onSuccess(async () => {
          eventBus.$emit('getQuery')
        })
        .params({
          scope: this.from,
          type: this.paramsType,
          config: result
        })
        .fetch()
      this.myList = []
    },
    handleCancel () {
      this.hide()
    },
    prepareTreeData (obj) {
      obj.children = []
      for (let k in obj.child) {
        let item = obj.child[k]
        item.title = item.fieldname
        item.key = item.fieldkey
        item.checked = !!item.ischecked
        obj.children.push(item)
        if (item.child) {
          this.prepareTreeData(item)
        }
      }
    },
    /**
     * 点击左侧树复选框的事件
     */
    onCheck (checkedKeys = [], info = {}) {
      this.checkedKeys = checkedKeys
      const { node = {} } = info
      const { dataRef = {} } = node
      const { fieldkey = '' } = dataRef
      this.setTreeDataChecked(dataRef, fieldkey)
    },
    /**
     * 通过左侧树 选中状态，获取所有checkedKeys
     */
    getCheckedKeys (children) {
      if (!children || !children.length) return
      for (let item of children) {
        if (item.ischecked) {
          if (!this.checkedKeys.includes(item.fieldkey)) {
            this.checkedKeys.push(item.fieldkey)
          }
        }
        if (item.children) {
          let checkArray = []
          item.children.map(items => {
            if (items.ischecked) {
              checkArray.push(items)
            }
          })
          if (checkArray.length === item.children.length) {
            item.ischecked = 1
            this.checkedKeys.push(item.fieldkey)
          }
          this.getCheckedKeys(item.children)
        }
      }
    },
    /**
     * 左侧树 选中/取消 的值，同步到 右侧结果列表
     */
    setTreeDataChecked (currentNode, currKey) {
      if (!currentNode.children || !currentNode.children.length) { // 点的子级
        if (this.checkedKeys.includes(currKey) && !this.myList.includes(currKey)) { // 点中
          this.$set(currentNode, 'ischecked', 1)
          this.myList.push(currentNode)
        } else {
          // 取消选中
          this.$set(currentNode, 'ischecked', 0)
          for (let index in this.myList) {
            if (this.myList[index].fieldkey === currentNode.fieldkey) {
              this.myList.splice(index, 1)
            }
          }
        }
      } else { // 点的父级
        let arr = []
        this.mergeChildren(arr, currentNode.children)
        if (this.checkedKeys.includes(currKey)) { // 点中
          this.setChecked(currentNode.children, 1)
          for (let item of arr) {
            if (!this.myList.map(items => items.fieldkey).includes(item.fieldkey)) {
              this.myList.push(item)
            }
          }
        } else { // 取消选中
          this.setChecked(currentNode.children, 0)
          for (let i = this.myList.length - 1; i >= 0; i--) {
            const one = this.myList[i] || {}
            for (let item of arr) {
              if (item.fieldkey === one.fieldkey) {
                this.myList.splice(i, 1)
              }
            }
          }
        }
      }
    },
    /**
     * 左侧树 选中 父级时，合并所有子元素到一个数组
     */
    mergeChildren (arr, children) {
      if (children && children.length) {
        for (let item of children) {
          if (!item.children) {
            arr.push(item)
          } else {
            this.mergeChildren(arr, item.children)
          }
        }
      }
    },
    /**
     * 设置左侧树选中状态
     */
    setChecked (children, type) {
      if (!children || !children.length) return
      for (let item of children) {
        this.$set(item, 'ischecked', type)
        if (item.children) {
          this.setChecked(item.children, type)
        }
      }
    },
    /**
     * 右侧数据拖拽
     */
    dragEndHandle ({ oldIndex, newIndex }) {
      const currentItem = this.myList[oldIndex]
      this.myList.splice(oldIndex, 1)
      this.myList.splice(newIndex, 0, currentItem)
      this.checkedKeys = this.myList.map(item => item.fieldkey)
      this.$forceUpdate()
    },
    // 删除右侧字段
    onDeleteItem (item, index) {
      this.myList.splice(index, 1)
      this.checkedKeys = this.myList.map(item => item.fieldkey)
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss">
.filter-config-modal {
  .ant-modal {
    padding-bottom: 0;
  }
  .ant-modal-body {
    padding: 16px 40px;
  }
  .ant-tree li span.ant-tree-switcher {
    color: #ccc;
  }
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_open
    .ant-tree-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_open
    .ant-select-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_close
    .ant-tree-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_close
    .ant-select-switcher-icon {
    font-size: 24px;
    color: #999;
  }
  .ant-tree > li {
    > .ant-tree-node-content-wrapper {
      .ant-tree-title {
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.content {
  position: relative;
  h3 {
    height: 48px;
    line-height: 48px;
    font-weight: bold;
  }
  .left {
    width: 250px;
    margin-right: 40px;
    .result {
      max-height: 524px;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  .border {
    position: absolute;
    left: 250px;
    top: 0;
    width: 0;
    height: 100%;
    border-right: solid 1px $gray4;
  }
  .right {
    width: 260px;
    .result {
      max-height: 524px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .item {
      overflow: hidden;
      height: 32px;
      line-height: 32px;
      padding: 0 12px;
      &:hover {
        background-color: #f4f7f9;
        .iconfont.move-icon {
          opacity: 1;
        }
      }
    }
    .dray-item {
      cursor: move;
    }
    .iconfont.move-icon {
      opacity: 0;
      margin-right: 4px;
      color: #ccc;
    }
    .iconfont.close-icon {
      margin-right: 20px;
      cursor: pointer;
      color: #d6d6d6;
    }
  }
}
.footer {
  text-align: right;
}
</style>
